import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const PlaylistsGrid = React.lazy(() => import("@mediaspace/features/playlists-grid"));

export const render = getDsLayoutComponentRenderer(PlaylistsGrid);
